import type { ReactNode } from "react";

/** The frame of the screens that stand alone (sign-in, change of password): the name of the app and one card. */
export function PlainFrame({ children }: { children: ReactNode }) {
  return (
    <div className="plain-frame">
      <header className="plain-frame__bar">
        <span className="shell__brand">E-NEX ontology</span>
      </header>
      <main id="main" className="plain-frame__main stack">
        {children}
      </main>
    </div>
  );
}
